import React, { useEffect, useRef, useState } from "react";
import Accordion from "../../../../components/Accordion/Accordion";
import Buttons from "../../../../components/ui/button/Buttons";
import MolGrid from "../../../../components/Grid/MolGrid";
import { PricingTableConfig } from "./PricingTableConfig";
import { useParams } from "react-router-dom";
import { decryptAESID } from "../../../../utils/Encryption";
import { useGenerateQuotationMutation, useGetMemberhipPricingDetailsByIdMutation } from "../../../../app/services/CorporateMembershipTaskList/corporateMembershipTaskListApi";
import SwalAlert from "../../../../services/swalService/SwalService";
import Checkbox from "../../../../components/ui/inputs/checkBox/CheckBox";

const PricingTableForm = ({ subscriptionType, refresh, tasklistId, isViewOnly, isAppLocked ,isQuotation}) => {
  const molGridRef = useRef();
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const [dataSource, setDataSource] = useState();
  const { success } = SwalAlert();
  const [getMemberhipPricing, { data: getMemberhipPricingData, isLoading: getMemberhipPricingIsLoading, isFetching: getMemberhipPricingIsFetching, },] = useGetMemberhipPricingDetailsByIdMutation();
  const [generateQuotation, { data: generateQuotationData, isLoading: generateQuotationIsLoading, isFetching: generateQuotationIsFetching, },] = useGenerateQuotationMutation();

  useEffect(() => {
    if (!getMemberhipPricingIsLoading && getMemberhipPricingData) {
      const formatted = getMemberhipPricingData.map(item => ({
        ...item,
        cost: item.cost.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      }));
      setDataSource(formatted);
    }
  }, [getMemberhipPricingIsLoading, getMemberhipPricingData]);

  useEffect(() => {
    if (!generateQuotationIsLoading && generateQuotationData) {
      success("Generate quotation successfully.");
    }
  }, [generateQuotationIsLoading, generateQuotationData]);

  const handleGenerate = () => {
    const pricingLists = (dataSource || []).map(item => ({
      itemDescription: item.itemDescription,
      cost: Number(item.cost.replace(/[^0-9.-]+/g, ""))
    }));

    let request = {
      SGBCCorporateMemberId: editID,
      SGBCCorporateMembberTaskListId: tasklistId,
      pricingLists: pricingLists
    };
    generateQuotation(request);
  };

  useEffect(() => {
    let request = {
      SGBCCorporateMemberId: tasklistId,
      MembershipPaymentTypeId: subscriptionType || null,
    };
    getMemberhipPricing(request);
  }, [refresh]);


  return (
    <Accordion title="Pricing Table" button={false} accordion={false}>
      <div className="pricing-table-data pt-3">
        {getMemberhipPricingData &&
          <MolGrid
            ref={molGridRef}
            configuration={PricingTableConfig}
            dataSource={dataSource}
            allowPagination={false}
          />
        }
      </div>

      <div className="btn-right-side mt-5 center-check-box">
          <Checkbox
            // key={id}
            // name={id}
            // dataField={dataField}
            label={"Quotation Required"}
            // checked={instrumentInclude[item.id] || false}
            // onChange={(dataField, isChecked) =>
            //   handleCheckboxChange(dataField, isChecked)
            // }
            checked={isQuotation}
            isDisable={true}
            onChange={(e) => console.log(e)}
          />
        <Buttons
          buttonText="Generate Quotation"
          buttonTypeClassName="warning-btn"
          onClick={handleGenerate}
          isLoading={generateQuotationIsLoading}
          isDisable={generateQuotationIsLoading || isViewOnly || isAppLocked}
        />
      </div>
    </Accordion>
  );
};
export default PricingTableForm;
